import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialoge',
  templateUrl: './dialoge.component.html',
  styleUrls: ['./dialoge.component.css']
})
export class DialogeComponent {
  title!: string;
  message!: string;
  prefix!: string;
  constructor( public dialogRef: MatDialogRef<DialogeComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any) { }

  ngOnInit(): void {
    this.title=this.dialogData.title
    this.message=this.dialogData.message
    this.prefix=this.dialogData.prefix
  }

  decline()
  {
    this.dialogRef.close({event:'No'});
  }
  accept()
  {
    this.dialogRef.close({event:'Yes'});
  }
  dismiss()
  {
    this.dialogRef.close({event:'Cancel'});
  }
}
